const en = {
  language: { label: 'Language' },
  nav: {
    gift: 'Gift · 90 Days Free',
    pricing: 'Plans & Pricing',
    features: 'Features',
    ecosystem: 'Family Ecosystem',
    clubs: 'Clubs',
    academy: 'Academy',
    lab: 'ROMIND LAB',
    safety: 'Safety',
    research: 'Research',
    insights: 'Insights',
    about: 'About',
    parentSafety: 'Parent Safety Overview',
    joinTesting: 'Join Testing',
    contact: 'Contact',
    toggleMenu: 'Toggle menu',
  },
  download: {
    nav: 'Download App',
    cta: 'Download on Google Play',
    available: 'Available Now',
    headline: 'ROMIND KIDS is live on Google Play!',
    description: 'Friendship, creativity and learning in one safety-focused world for ages 9–14. Download the Android app and explore ROMIND KIDS.',
    scan: 'Scan the QR code to open ROMIND KIDS on Google Play.',
    qrAlt: 'QR code to download ROMIND KIDS from Google Play',
  },
  footer: {
    tagline: 'A safer creative universe for children aged 9–14 — and the foundation of the ROMIND Family Circle.',
    platform: 'Platform',
    legal: 'Legal',
    home: 'Home',
    features: 'ROMIND KIDS Features',
    ecosystem: 'Family Ecosystem',
    clubs: 'Clubs & Challenges',
    academy: 'ROMIND Academy',
    lab: 'ROMIND LAB',
    ventureStudio: 'Venture Studio',
    safety: 'Safety',
    safetyResearch: 'Safety Research',
    parentSafety: 'Parent Safety Overview',
    insights: 'Insights',
    joinTesting: 'Join Testing',
    about: 'About',
    contact: 'Contact',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    copyright: 'User Content & Copyright',
    community: 'Community Guidelines',
    childSafetyModeration: 'Child Safety & Moderation',
    reportHandling: 'Report Handling',
    dataRetention: 'Data Retention & Deletion',
    deleteAccount: 'Delete Account',
    childSafetyOverview: 'Child Safety Overview',
    childSafetyResearch: 'Child Safety Research',
    rights: '© 2025–2026 ROMIND KIDS — a founder-operated project. All rights reserved.',
    safetyPrinciples: 'Designed with child safety principles',
  },
  legal: {
    eyebrow: 'Legal',
    back: 'Back to ROMIND KIDS',
    lastUpdated: 'Last updated: {date}',
    operatorInfo: 'Operator information:',
    otherDocs: 'Other legal and safety documents',
  },
};

export default en;